import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "./utils";

interface AdminFormFieldProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  description?: ReactNode;
  error?: ReactNode;
  htmlFor?: string;
  label: ReactNode;
  labelClassName?: string;
  required?: boolean;
}

const AdminFormField = ({
  children,
  className,
  description,
  error,
  htmlFor,
  label,
  labelClassName,
  required = false,
  ...props
}: AdminFormFieldProps) => (
  <div className={cn("space-y-1.5", className)} {...props}>
    <label htmlFor={htmlFor} className={cn("flex min-h-4 items-center gap-1 text-xs font-medium text-slate-600", labelClassName)}>
      <span>{label}</span>
      {required && (
        <>
          <span aria-hidden="true" className="text-rose-500">*</span>
          <span className="sr-only">필수 입력</span>
        </>
      )}
    </label>
    {children}
    {description && !error && <p className="text-xs leading-relaxed text-slate-400">{description}</p>}
    {error && <p className="text-xs leading-relaxed text-rose-600">{error}</p>}
  </div>
);

export default AdminFormField;
